import React, { useRef } from "react";
import { galleryCards } from "../mock";
import GalleryCard from "./GalleryCard";

export default function Gallery() {
  const stripRef = useRef(null);
  const drag = useRef({ down: false, startX: 0, scrollLeft: 0, moved: false });

  const onDown = (e) => {
    const el = stripRef.current;
    drag.current = {
      down: true,
      startX: e.pageX - el.offsetLeft,
      scrollLeft: el.scrollLeft,
      moved: false,
    };
    el.classList.add("dragging");
  };
  const onMove = (e) => {
    if (!drag.current.down) return;
    e.preventDefault();
    const el = stripRef.current;
    const x = e.pageX - el.offsetLeft;
    const walk = x - drag.current.startX;
    if (Math.abs(walk) > 4) drag.current.moved = true;
    el.scrollLeft = drag.current.scrollLeft - walk;
  };
  const onUp = () => {
    drag.current.down = false;
    stripRef.current?.classList.remove("dragging");
  };

  return (
    <section id="gallery">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow" data-reveal="fade">Inside Cloud9</span>
          <h2 data-reveal="fade" data-reveal-delay="1">One room, six corners.</h2>
          <p data-reveal="fade" data-reveal-delay="2">
            No two tables at Cloud9 face the same wall. Drag across for a look at each counter.
          </p>
        </div>
      </div>
      <div className="wrap">
        <div
          className="gallery-strip"
          ref={stripRef}
          onMouseDown={onDown}
          onMouseMove={onMove}
          onMouseUp={onUp}
          onMouseLeave={onUp}
        >
          {galleryCards.map((c, i) => (
            <GalleryCard card={c} delay={String(i % 4)} key={c.n} />
          ))}
        </div>
      </div>
    </section>
  );
}
